import { useEffect, useState } from "react";
import { Hourglass } from "lucide-react";

const parts = (ms) => {
  const s = Math.floor(Math.abs(ms) / 1000);
  return { d: Math.floor(s / 86400), h: Math.floor((s % 86400) / 3600), m: Math.floor((s % 3600) / 60), s: s % 60 };
};
const pad = (n) => String(n).padStart(2, "0");
// deadline is Riyadh local time "YYYY-MM-DDTHH:MM"
export const deadlineMs = (dl) => new Date(`${dl.length === 10 ? `${dl}T23:59` : dl}:00+03:00`).getTime();

export const LegalCountdown = ({ timer, compact = false, testId }) => {
  const [now, setNow] = useState(Date.now());
  useEffect(() => { const t = setInterval(() => setNow(Date.now()), compact ? 30000 : 1000); return () => clearInterval(t); }, [compact]);
  if (!timer?.deadline) return null;
  const left = deadlineMs(timer.deadline) - now;
  const p = parts(left);
  const ended = left <= 0;
  const tone = ended ? "bg-rose-600 text-white" : left < 86400000 ? "bg-rose-50 text-rose-700 ring-1 ring-rose-200" : left < 3 * 86400000 ? "bg-amber-50 text-amber-800 ring-1 ring-amber-200" : "bg-emerald-50 text-emerald-800 ring-1 ring-emerald-200";
  if (compact) {
    return (
      <span className={`inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-[10px] font-bold ${tone}`} data-testid={testId}>
        <Hourglass className="h-3 w-3" />{ended ? "انتهى المؤقت" : p.d ? `${p.d} ي ${p.h} س` : `${p.h} س ${p.m} د`}
      </span>
    );
  }
  return (
    <div className={`flex flex-wrap items-center gap-3 rounded-xl px-3 py-2 ${tone}`} data-testid={testId}>
      <Hourglass className={`h-5 w-5 ${ended ? "" : "animate-pulse"}`} />
      <div className="text-xs"><p className="font-bold">{timer.label || "المؤقت الزمني"}</p><p className="opacity-80" dir="ltr">{timer.deadline.replace("T", " ")}</p></div>
      <div className="ms-auto flex items-end gap-2" dir="ltr">
        {ended && <span className="text-xs font-bold">منذ</span>}
        {[[p.d, "يوم"], [pad(p.h), "ساعة"], [pad(p.m), "دقيقة"], [pad(p.s), "ثانية"]].map(([v, l]) => (
          <span key={l} className="text-center"><b className="block text-xl tabular-nums leading-none">{v}</b><span className="text-[9px]">{l}</span></span>
        ))}
      </div>
    </div>
  );
};
